const state = {
  filters: []
};

const getters = {
  getFilters: state => {
    return state.filters;
  }
};

const actions = {
  setFilters(context, filters) {
    context.commit('setFiltersHandler', filters)
  }
};

const mutations = {
  setFiltersHandler(state, filters) {
    state.filters = filters;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/index.js